import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_URL} from '../constants';

export interface MOMDTO {
    id?: string;
    title: string;
    chapterId: string;
    userId: string;
    createdDate: Date | string;
    createdBy: string;
    updatedBy: string;
    updatedDate: string;
    description: string;
    visible: boolean;
    createdByName?: string;

}

@Injectable({
    providedIn: 'root',
})
export class MOMService {
    private apiUrl = `${API_URL}` + 'moms'; // Base API URL

    constructor(private http: HttpClient) {
    }


    /**
     * Get a mom by its ID.
     * @param id The ID of the mom.
     */
    getMOMById(id: string): Observable<MOMDTO> {
        return this.http.get<MOMDTO>(`${this.apiUrl}/${id}`);
    }

    /**
     * Create a new mom.
     * @param mom The mom data to create.
     */
    createMOM(mom: MOMDTO): Observable<MOMDTO> {
        return this.http.post<MOMDTO>(this.apiUrl, mom);
    }

    /**
     * Update an existing mom by ID.
     * @param id The ID of the mom to update.
     * @param mom The updated mom data.
     */
    updateMOM(id: string, mom: MOMDTO): Observable<MOMDTO> {
        return this.http.put<MOMDTO>(`${this.apiUrl}/${id}`, mom);
    }

    /**
     * Delete a mom by its ID.
     * @param id The ID of the mom to delete.
     */
    deleteMOM(id: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    /**
     * Get moms by chapter ID.
     * @param chapterId The ID of the chapter.
     */
    getMOMsByChapterId(chapterId: string): Observable<MOMDTO[]> {
        return this.http.get<MOMDTO[]>(`${this.apiUrl}/chapter/${chapterId}`);
    }
}
